module.exports = __webpack_public_path__ + "img/ax.7906a8bb.png";